import ActionTypes from '../constants/ActionTypes';

export const showSystemCheck = () => ({
  type: ActionTypes.SHOW_SYSTEM_CHECK,
});

export const hideSystemCheck = () => ({
  type: ActionTypes.HIDE_SYSTEM_CHECK,
});

export const setRequiredDeviceKinds = (kinds, reason) => ({
  type: ActionTypes.SET_REQUIRED_DEVICE_KINDS,
  payload: { kinds: kinds || [], reason: reason || null },
});

export const clearRequiredDeviceKinds = () => ({
  type: ActionTypes.CLEAR_REQUIRED_DEVICE_KINDS,
});

// Notifies all components that the device has changed via system check modal
// during an ongoing assessment, so they can re-acquire streams with the updated device.
export const bumpDeviceRefresh = () => ({
  type: ActionTypes.BUMP_DEVICE_REFRESH,
});

export const enableWebcam = () => ({
  type: ActionTypes.ENABLE_WEBCAM,
});

export const disableWebcam = () => ({
  type: ActionTypes.DISABLE_WEBCAM,
});

export const allowWebcamPermission = payload => ({
  type: ActionTypes.ALLOW_WEBCAM_PERMISSION,
  payload,
});

export const allowAudioPermission = payload => ({
  type: ActionTypes.ALLOW_MIC_PERMISSION,
  payload,
});

export const audioPermissionLoading = payload => ({
  type: ActionTypes.MIC_PERMISSION_LOADING,
  payload,
});

export const webcamPermissionLoading = payload => ({
  type: ActionTypes.WEBCAM_PERMISSION_LOADING,
  payload,
});

export const denyWebcamPermission = () => ({
  type: ActionTypes.DENY_WEBCAM_PERMISSION,
});

export const denyAudioPermission = payload => ({
  type: ActionTypes.DENY_MIC_PERMISSION,
  payload,
});

export const setWebcamException = payload => ({
  type: ActionTypes.SET_WEBCAM_EXCEPTION,
  payload,
});

export const enableSnapshotInterval = payload => ({
  type: ActionTypes.ENABLE_SNAPSHOT_INTERVAL,
  payload,
});

export const disableSnapshotInterval = () => ({
  type: ActionTypes.DISABLE_SNAPSHOT_INTERVAL,
});

export const uploadFailedProctorImages = payload => ({
  type: ActionTypes.UPLOAD_FAILED_PROCTOR_IMAGES,
  payload,
});

export const uploadSnapshot = (
  signedUrl,
  originalBase64Image,
  contentType,
  eventGuid,
  retryCounter,
  isProctoringABEnabled
) => ({
  type: ActionTypes.UPLOAD_SNAPSHOT,
  signedUrl,
  originalBase64Image,
  contentType,
  eventGuid,
  retryCounter,
  isProctoringABEnabled,
});

export const checkHasIdentityImage = (assessmentType, assessmentId) => ({
  type: ActionTypes.HAS_IDENTITY_IMAGE,
  assessmentType,
  assessmentId,
});

export const getIdentityDetails = ({
  assessmentType,
  assessmentId,
  identity,
  idCard,
  audioSample,
}) => ({
  type: ActionTypes.GET_IDENTITY_DEATILS,
  assessmentType,
  assessmentId,
  identity,
  idCard,
  audioSample,
});

export const uploadIdentityImage = img => ({
  type: ActionTypes.UPLOAD_IDENTITY_IMAGE,
  img,
});

export const uploadIdProofImage = img => ({
  type: ActionTypes.UPLOAD_IDPROOF_IMAGE,
  img,
});

export const uploadAudioSample = audioFile => ({
  type: ActionTypes.UPLOAD_AUDIO_SAMPLE,
  audioFile,
});

export const enableFullScreen = () => ({
  type: ActionTypes.ENABLE_FULLSCREEN,
});

export const disableFullScreen = () => ({
  type: ActionTypes.DISABLE_FULLSCREEN,
});

export const emitWebcamEvent = payload => ({
  type: ActionTypes.EMIT_WEBCAM_EVENT,
  payload,
});

export const enableVisibility = () => ({
  type: ActionTypes.ENABLE_VISIBILITY,
});

export const disableVisibility = () => ({
  type: ActionTypes.DISABLE_VISIBILITY,
});

export const showBrowserToleranceModal = () => ({
  type: ActionTypes.SHOW_BROWSER_TOLERANCE_MODAL,
});

export const hideBrowserToleranceModal = () => ({
  type: ActionTypes.HIDE_BROWSER_TOLERANCE_MODAL,
});

export const initializeBrowserTolerance = (count, testSlug) => ({
  type: ActionTypes.INITILIZE_BROWSER_TOLERANCE,
  testSlug,
  count,
});

export const decrementBrowserToleranceCount = testSlug => ({
  type: ActionTypes.DECREMENT_BROWSER_TOLERANCE_COUNT,
  testSlug,
});

export const setProctoringABEnabled = isEnabled => ({
  type: ActionTypes.SET_PROCTORING_AB_ENABLED,
  isEnabled,
});

export const setProctorBatchABEnabled = isEnabled => ({
  type: ActionTypes.SET_PROCTOR_BATCH_AB_ENABLED,
  isEnabled,
});

export const updateProctoringSignedUrls = (payload, retryCounter) => {
  return {
    type: ActionTypes.UPDATE_PROCTORING_SIGNED_URLS,
    payload,
    retryCounter,
  };
};

export const updateSignedUrlsFromCache = updatedSignedUrls => ({
  type: `${ActionTypes.UPDATE_PROCTORING_SIGNED_URLS}_FROM_CACHE`,
  updatedSignedUrls,
});

export const setProctorNextImageSequence = payload => ({
  type: ActionTypes.SET_NEXT_PROCTOR_IMAGE_SEQUENCE,
  payload,
});

export const setProctorTestSubmit = payload => ({
  type: ActionTypes.SET_PROCTOR_IS_TEST_SUBMITTED,
  payload,
});

export const setProctorSessionId = payload => ({
  type: ActionTypes.SET_PROCTOR_SESSION_ID,
  payload,
});

export const setProctorTabId = payload => ({
  type: ActionTypes.SET_PROCTOR_TAB_ID,
  payload,
});

export const evaluateWebsocketBrowserToleranceCount = (testSlug, count) => ({
  type: ActionTypes.EVALUATE_WEBSOCKET_BROWSER_TOLERANCE_COUNT,
  testSlug,
  count,
});

export const leaveTestViolationAction = payload => ({
  type: ActionTypes.LEAVE_TEST_VIOLATION,
  payload,
});

export const multiSessionActive = () => ({
  type: ActionTypes.MULTI_SESSION_ACTIVE,
});

export const secureBrowserMetaInfo = payload => ({
  type: ActionTypes.SECURE_BROWSER_SYSTEM_CHECK,
  payload,
});

export const reCheckSystemReq = () => ({
  type: ActionTypes.RECHECK_SYSTEM_REQ,
});

// Audio proctoring actions
export const getAudioProctorSignedUrl = payload => ({
  type: ActionTypes.GET_AUDIO_PROCTOR_SIGNED_URL,
  payload,
});

export const uploadAudioProctorSegment = payload => ({
  type: ActionTypes.UPLOAD_AUDIO_PROCTOR_SEGMENT,
  payload,
});

export const processAudioProctorIncident = payload => ({
  type: ActionTypes.PROCESS_AUDIO_PROCTOR_INCIDENT,
  payload,
});

export const setVADBlockingProblemType = problemType => ({
  type: ActionTypes.SET_VAD_BLOCKING_PROBLEM_TYPE,
  payload: problemType,
});

export const retakeIdentityCardSnapshot = () => ({
  type: ActionTypes.RETAKE_IDPROOF_SNAPSHOT,
});

export const retakeAudioSample = () => ({
  type: ActionTypes.RETAKE_AUDIO_SAMPLE,
});

export const incrementWebcamRenderKey = () => ({
  type: ActionTypes.INCREMENT_WEBCAM_RENDER_KEY,
});
